import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import api from "../../api/apiClient";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import "./CreateGroupModal.css";


const FileUploadModal = ({ isOpen, toggle }) => {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type !== "application/pdf") {
      toast.error("Only PDF files are allowed.");
      setFile(null);
      e.target.value = null; // Clear the input
    } else {
      setFile(selectedFile);
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      toast.error("Please select a file");
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      await api.post("/upload-manual", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("File uploaded successfully");
      toggle();
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Error uploading file");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Upload File</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="fileUpload">File</Label>
            <Input
              type="file"
              name="file"
              id="fileUpload"
              onChange={handleFileChange}
              disabled={isLoading}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className="create-button" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? (
            <>
              <FaSpinner className="spinner" /> Uploading...
            </>
          ) : (
            "Save"
          )}
        </Button>{" "}
        <Button color="secondary" className="cance-button" onClick={toggle} disabled={isLoading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FileUploadModal;
